export default {
  functions: [
    {
      name: 'getCPCartItems',
      type: 'angularData',
      options: {
        source: 'appExtensionSdkData',
        key: 'cpCartItems',
      },
    },
  ],
};
